import React, { FC, useState } from 'react';

import { Avatar, Button, Flex, Heading, Stack, Text } from '@chakra-ui/react';

import { ScanDetailsViewProps } from './ScanDetails.props';
import { UserPill } from 'components/core/UserPill';
import { ScansItemsTable } from './ScansItemsTable';
import { rolesMap } from 'components/modules/EditEmployeeModal/EditEmployeeModal.utils';

import { ScansCasesTable } from './ScansCasesTable';
import { convertUTCToLocal } from 'utils/dateUtils';

const ScanDetailsView: FC<ScanDetailsViewProps> = ({ scan }) => {
  const [type, setType] = useState<'item' | 'case'>('item');

  return (
    <Flex direction="column" flex={1} color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading fontSize="24px">Scan Details</Heading>
        <Flex align="flex-end">
          <UserPill />
        </Flex>
      </Flex>

      <Flex my={8} justify="space-between">
        <Stack isInline align="center">
          <Avatar size="lg" />
          <Stack spacing={0}>
            <Text fontWeight="bold">
              {scan?.scanPerformedBy?.fname} {scan?.scanPerformedBy?.lname}
            </Text>
            <Text>
              {rolesMap[scan?.scanPerformedBy?.permissions?.[0]?.role as any] ||
                ''}
            </Text>
          </Stack>
        </Stack>
        <Flex>
          <Stack spacing={0} mr={5}>
            <Text fontWeight="bold">Transaction</Text>
            <Text>{scan?.scanId || ''}</Text>
          </Stack>
          <Stack spacing={0}>
            <Text fontWeight="bold">Scanned At</Text>
            <Text>{convertUTCToLocal(scan?.performedAt, true)}</Text>
          </Stack>
        </Flex>
      </Flex>
      <Stack mb={6} isInline>
        <Button
          w="180px"
          borderRadius="5px"
          variant={type === 'item' ? 'solid' : 'outline'}
          size="lg"
          onClick={() => setType('item')}>
          Items
        </Button>
        <Button
          w="180px"
          borderRadius="5px"
          variant={type === 'case' ? 'solid' : 'outline'}
          size="lg"
          onClick={() => setType('case')}>
          Cases
        </Button>
      </Stack>

      {type === 'item' ? <ScansItemsTable /> : <ScansCasesTable />}
    </Flex>
  );
};

export default ScanDetailsView;
